import React from 'react';
import { useState } from 'react';
import { css } from '@emotion/react';
import { routes } from 'routes';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';

import { PaddingStyle } from 'styles/PaddingStyle';

import { RequestDetailDrawer } from './drawer/RequestDetailDrawer';
import { useModal } from 'hooks/useModal';
import { useQueryParam } from 'hooks/useQueryParam';

import { ButtonLink } from 'components/ButtonLink';
import { SpinnerBlock } from 'components/SpinnerBlock';

import { RequestExportDrawer } from './drawer/RequestExportDrawer';
import { theme } from 'styles/theme';
import { IconSearch } from 'icons/icon-search';

import { ListingTabs } from './components/ListingTabs';
import { EmptyList, emptyListingMessage } from './components/EmptyList';
import { RequestItem } from './components/RequestItem';
import { NotifyRequestModal } from 'components/Modals/NotifyRequestModal';
import {
	RequestType,
	useOrganizationQuery,
	useRequestCountsQuery,
	useRequestsQuery,
} from 'generated/graphql';
import { Controller, useForm } from 'react-hook-form';
import { SelectArtists } from './components/SelectArtists';
import { Button } from 'components/Button';
import { InputDebounced } from 'components/InputDebounced';
import { useSearchParams } from 'react-router-dom';

export enum LISTING_TYPE {
	SUBMITTED = 'SUBMITTED',
	COMPLETED = 'COMPLETED',
	INCOMPLETED = 'INCOMPLETED',
	UNSUBMITTED = 'UNSUBMITTED',
	EXPORTED = 'EXPORTED',
	NOTEXPORTED = 'NOTEXPORTED',
	PAST = 'PAST',
}

export const ScreenRequests = () => {
	const [urlSearchParams, setUrlSearchParams] = useSearchParams();

	const listingType = useQueryParam('type');

	const searchVal = urlSearchParams.get('search');
	const artistsIds = urlSearchParams.getAll('artistsIds');

	const {
		control,
		reset,
		formState: { isDirty },
	} = useForm({
		defaultValues: { search: searchVal, artistsIds: artistsIds },
	});

	const [requestCounts, _executeRequestsCounts] = useRequestCountsQuery({
		variables: { filter: { query: searchVal, artistIds: artistsIds } },
	});

	const [requests, _executeRequests] = useRequestsQuery({
		variables: {
			type: listingType ?? RequestType.Submitted,
			filter: { query: searchVal, artistIds: artistsIds },
			// filter: { query: searchVal },
		},
	});

	const { data, fetching } = requests;

	// const onSearchSubmit = () => {

	// ERROR GRAPHQL CALLINS?
	// useEffect(() => {
	// 	executeRequests({
	// 		variables: { type: listingType ?? RequestType.Submitted, filter: { query: searchVal } },
	// 	});
	// }, [executeRequests, listingType, searchVal]);

	// };

	const [isOpen, open, close] = useModal();
	const [isExportOpen, exportOpen, exportClose] = useModal();
	const [isNotifyOpen, notifyOpen, notifyClose] = useModal();

	const [detailRequestUrl, setDetailRequestUrl] = useState(null);
	const [exportRequestUrl, setExportRequestUrl] = useState(null);
	const [notifyRequestUrl, setNotifyRequestUrl] = useState(null);

	const [organization, _executeOrganization] = useOrganizationQuery();

	if (fetching && organization.fetching) return <SpinnerBlock />;

	return (
		<div
			css={css`
				width: 100%;
			`}
		>
			<Header>
				<Heading
					left={
						<div
							css={css`
								display: flex;
								align-items: center;

								gap: 20px;
							`}
						>
							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;
								`}
							>
								Poptávky
							</h1>

							<ButtonLink small to={routes.booker.requestCreate}>
								Přidat poptávku
							</ButtonLink>

							<form
								css={css`
									// width: 560px;
									display: flex;
									gap: 8px;
								`}
							>
								<div
									css={css`
										width: 360px;
									`}
								>
									<Controller
										name="search"
										control={control}
										render={({ field }) => {
											const { onChange } = field;

											return (
												<InputDebounced
													{...field}
													onChange={(value) => {
														onChange(value);

														setUrlSearchParams((searchParams) => {
															const newParams = new URLSearchParams(searchParams);
															newParams.set('search', value.currentTarget.value);

															return newParams;
														});
													}}
													sizeMedium
													icon={<IconSearch />}
													placeholder="Hledat akci, město, místo..."
												/>
											);
										}}
									/>
								</div>

								<Controller
									name="artistsIds"
									control={control}
									render={({ field }) => {
										const { onChange } = field;

										return (
											<SelectArtists
												{...field}
												onChange={(value) => {
													onChange(value);

													setUrlSearchParams((searchParams) => {
														const newParams = new URLSearchParams(searchParams);

														newParams.delete('artistsIds');

														value.forEach((artist) => newParams.append('artistsIds', artist));

														return newParams;
													});
												}}
											/>
										);
									}}
								/>

								{(searchVal || !!artistsIds.length) && (
									<div>
										<Button
											ghost
											small
											type="button"
											onClick={() => {
												setUrlSearchParams((searchParams) => {
													const newParams = new URLSearchParams(searchParams);

													newParams.delete('artistsIds');
													newParams.delete('search');

													return newParams;
												});

												reset({ search: '', artistsIds: [] });
											}}
										>
											Zrušit fitltry
										</Button>
									</div>
								)}
							</form>
						</div>
					}
					// right={}
				></Heading>
				<div
					css={css`
						display: flex;
						gap: 24px;
					`}
				>
					<ListingTabs listingType={listingType} requestCounts={requestCounts} />
				</div>
			</Header>
			<div
				css={css`
					font-size: 13px;
					line-height: 20px;
					padding: 12px 32px;
					color: ${theme.color.text[300]};
				`}
			>
				{emptyListingMessage[listingType ?? LISTING_TYPE.SUBMITTED]}
			</div>
			{fetching ? (
				<SpinnerBlock />
			) : (
				<>
					{(!data?.requests.length || data?.requests == null) && (
						<div
							css={css`
								width: 100%;
								display: flex;
								justify-content: center;
								padding: 120px 32px;
							`}
						>
							<div
								css={css`
									text-align: center;
								`}
							>
								<EmptyList type={listingType} />
							</div>
						</div>
					)}

					{/* {(!!data?.requests.length || data?.requests == null) && (
						<div css={[PaddingStyle({ h: 32, t: 32 })]}>
							<div
								css={css`
									color: ${theme.color.text['300']};
								`}
							>
								{emptyListingMessage[listingType ?? LISTING_TYPE.SUBMITTED]}
							</div>
						</div>
					)} */}
					<div css={[PaddingStyle({ h: 32, t: 0, b: 32 })]}>
						{data?.requests?.map((props) => {
							return (
								<RequestItem
									key={props.id}
									open={open}
									setDetailRequestUrl={setDetailRequestUrl}
									setExportRequestUrl={setExportRequestUrl}
									setNotifyRequestUrl={setNotifyRequestUrl}
									notifyOpen={notifyOpen}
									exportOpen={exportOpen}
									listingType={listingType}
									{...props}
								/>
							);
						})}
					</div>
				</>
			)}
			{isOpen && (
				<RequestDetailDrawer
					onClose={() => {
						close();
						setDetailRequestUrl(null);
					}}
					url={detailRequestUrl}
				/>
			)}
			{isExportOpen && (
				<RequestExportDrawer
					onClose={() => {
						exportClose();
						setExportRequestUrl(null);
					}}
					url={exportRequestUrl}
				/>
			)}
			{isNotifyOpen && (
				<NotifyRequestModal
					onClose={() => {
						notifyClose();
						setNotifyRequestUrl(null);
					}}
					isOpen={true}
					url={notifyRequestUrl}
				/>
			)}
		</div>
	);
};
